import { render, staticRenderFns } from "./AssetTypeInventoryDetails.vue?vue&type=template&id=1f8582f4&scoped=true"
import script from "./AssetTypeInventoryDetails.vue?vue&type=script&lang=js"
export * from "./AssetTypeInventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeInventoryDetails.vue?vue&type=style&index=0&id=1f8582f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8582f4",
  null
  
)

export default component.exports